import { useRouter } from 'next/router';
import { isValidElement, ReactElement, ReactNode } from 'react';

import AiSearchBox from '@/modules/AiAgents/components/AiSearchBox';
import { Breadcrumbs } from '@/shared/components/atoms';
import DemoBanner from '@/shared/components/atoms/Demo/Banner';
import Tour from '@/shared/components/atoms/Demo/Tour';
import ChooseAsset from '@/shared/components/molecules/ChooseAsset';
import SubscribeBanner from '@/shared/components/molecules/Subscription/SubscribeBanner';
import { subscriptionBlacklist } from '@/shared/constant/routesBlacklist';
import { useStore } from '@/shared/hooks/context/createGenericContext';
import { useFreeTrial } from '@/shared/hooks/useFreeTrial';
import { clsxm } from '@/shared/lib';

type HeaderProps = {
  bgColor?: 'white' | 'grey' | 'light-grey';
  subHeader?: string | React.ReactElement;
  withBreadcrumbs?: ReactNode;
};

export default function Header({
  bgColor,
  subHeader,
  withBreadcrumbs,
}: HeaderProps): ReactElement {
  const headerClasses = clsxm(
    'sticky top-0 z-20 bg-background-body',
    bgColor === 'white' && 'bg-white',
    bgColor === 'grey' && 'bg-background-body',
    bgColor === 'light-grey' && 'bg-background-neutral-100'
  );

  const { pathname } = useRouter();
  const { hasFreeTrial, canAccessAssets } = useFreeTrial();
  const [isDemoFarm] = useStore((store) => store?.isDemoFarm);

  const showDemoBanner = hasFreeTrial && isDemoFarm;
  const showSubscribtionBanner =
    (hasFreeTrial && !isDemoFarm) || !canAccessAssets;

  return (
    <>
      {showSubscribtionBanner && !subscriptionBlacklist.includes(pathname) && (
        <SubscribeBanner />
      )}
      {showDemoBanner && <DemoBanner />}
      <div className={headerClasses}>
        <div className='mb-20 flex flex-wrap items-center justify-between py-20'>
          {withBreadcrumbs ? (
            <>{withBreadcrumbs}</>
          ) : (
            <Breadcrumbs
              subHeader={typeof subHeader === 'string' ? subHeader : undefined}
            />
          )}
          <AiSearchBox />
          <div className='demo-first-step'>
            <div className='hidden tablet:inline-block'>
              <ChooseAsset useBlackList />
            </div>
            <Tour />
          </div>
        </div>
        {isValidElement(subHeader) && subHeader}
      </div>
    </>
  );
}
